import React, { createContext, useContext, useState } from "react";
import { UserRoleValue } from "./roles";
import { getLoggedInUserName, getLoggedInUserRole, getUserGrades, isUserLoggedIn } from "../modules/common/user/UserService";

export interface AuthUser {
  name: string;
  role: UserRoleValue;
  // Grades the user works with, sent at login (attendance/fees filters). For a faculty these are the
  // grades they teach in the active year; changes apply at the next login.
  grades: string[];
}

interface AuthContextType {
  user: AuthUser | null;
  setUser: (user: AuthUser | null) => void;
  loaded: boolean;
  setLoaded: (status: boolean) => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

const restoreUserFromStorage = (): AuthUser | null => {
  if (!isUserLoggedIn()) return null;
  const role = getLoggedInUserRole();
  const name = getLoggedInUserName();
  if (!role || !name) return null;
  return { name, role: role as UserRoleValue, grades: getUserGrades() ?? [] };
};

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<AuthUser | null>(restoreUserFromStorage);
  const [loaded, setLoaded] = useState(true);

  return (
    <AuthContext.Provider value={{ user, setUser, loaded, setLoaded }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};